import styles from "./AuthLeftPanel.module.css";
import ComplianceBadges from "./ComplianceBadge";

const FEATURES = [
  {
    icon: "/images/tab1.svg",
    bg: "#e8f0fe",
    title: "Secure & Trusted",
    sub: "Enterprise-grade security to keep your data private and protected.",
  },
  {
    icon: "/images/tab2.svg",
    bg: "#e6f9f0",
    title: "Personalized Care",
    sub: "Tailored insights and recommendations based on your unique health.",
  },
  {
    icon: "/images/tab3.svg",
    bg: "#f3e8ff",
    title: "Connected Experience",
    sub: "Access your records, appointments, and care team—anytime, anywhere.",
  },
];

export default function AuthLeftPanel() {
  return (
     <div className={styles.panelOuter}>
    <div className={styles.panel}>
      {/* Headline */}
      <h1 className={styles.headline}>
        Your health.{" "}
        <span className={styles.accent}>Your partner.</span>
      </h1>

      <p className={styles.description}>
        Join Avexa OneCare™ to manage your health, connect with your care team,
        and access everything in one place.
      </p>

      {/* Feature list */}
      <ul className={styles.featureList}>
        {FEATURES.map((f, index) => (
          <>
            <li key={f.title} className={styles.featureItem}>
              <div
                className={styles.featureIcon}
                style={{ backgroundColor: f.bg }}
              >
                <img
                  src={f.icon}
                  alt=""
                  width={22}
                  height={22}
                  onError={(e) => { e.currentTarget.style.opacity = "0"; }}
                />
              </div>
              <div className={styles.featureBody}>
                <p className={styles.featureTitle}>{f.title}</p>
                <p className={styles.featureSub}>{f.sub}</p>
              </div>
            </li>
          </>
        ))}

      </ul>

      {/* Photo / trust card */}
      <div className={styles.photoContainer}>
        <div className={styles.photoCard}>
          <img
            src="/images/family.svg"
            alt="Family using health app"
            className={styles.photoImg}
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <div className={styles.trustBadge}>
            <div className={styles.trustIcon}>
              <img
                src="/images/tab4.svg"
                alt=""
                width={20}
                height={20}
                onError={(e) => { e.currentTarget.style.opacity = "0"; }}
              />
            </div>
            <div>
              <p className={styles.trustTitle}>Trusted by 2M+ patients</p>
              <p className={styles.trustSub}>across 1,000+ care centers</p>
            </div>
          </div>
        </div>
      </div>

      {/* Compliance */}
      <div className={styles.compliance}>
        <ComplianceBadges />
      </div>
    </div></div>
  );
}